import { IStory, IStoryContent } from '@opengov/stories-shared/types';
import React from 'react';
import { IUpdateStoryContentProps } from '../../../../../types/storyViewTypes';
import { EditCustomSpreadsheetMediaModal } from './EditCustomSpreadsheetMediaModal';
import { DeleteSpreadsheetMarkupModal } from './DeleteSpreadsheetMarkupModal';

type Props = {
  entityId: number;
  entitySubdomain: string;
  publicationId?: string;
  story: IStory;
  storyContent: IStoryContent;
  mediaIndex: number;
  updateStoryContent: (storyContent: IStoryContent) => void;
  updateStoryContentDB: (props: IUpdateStoryContentProps) => void;
  onClose: () => void;
};

export function EditCustomSpreadsheetMediaModalContainer({
  entityId,
  entitySubdomain,
  publicationId,
  story,
  storyContent,
  mediaIndex,
  updateStoryContent,
  updateStoryContentDB,
  onClose
}: Props) {
  if (!publicationId) {
    return (
      <DeleteSpreadsheetMarkupModal
        story={story}
        storyContent={storyContent}
        mediaIndex={mediaIndex}
        updateStoryContent={updateStoryContent}
        updateStoryContentDB={updateStoryContentDB}
        onClose={onClose}
      />
    );
  }

  return (
    <EditCustomSpreadsheetMediaModal
      publicationId={publicationId}
      onClose={onClose}
      storyContent={storyContent}
      story={story}
      entityId={entityId}
      entitySubdomain={entitySubdomain}
      updateStoryContent={updateStoryContent}
      updateStoryContentDB={updateStoryContentDB}
      mediaIndex={mediaIndex}
    />
  );
}
